/* GR-P1008-SOLDOUT (Claude 2026-10-08, picks-1008 "Sold-out sizes that keep the customer").
   1. PDP, a sold-out size (snippets/gr-p1008-soldout.liquid inside <buy-buttons>): the first tap on "Tell me when it's back"
      opens one email field in place; the same button then subscribes through the EXISTING back-in-stock mechanism, the exact
      Klaviyo client request snippets/product-info.liquid (GR-LUX1) sends: POST a.klaviyo.com/client/back-in-stock-subscriptions
      ?company_id=UiecjN, revision 2024-10-15, catalog-variant "$shopify:::$default:::<variant id>". No account, no new store.
      Delegated on document: the theme swaps <buy-buttons> on every size change, the handlers keep working.
      The press shows the house emblem through aria-busy (assets/gr-busy.js), like Add to cart.
   2. Homepage, "Or ask us to find it" lands on /?find=<name>&from=<handle>#special-orders: the Special Orders line is typed in
      before assets/gso-photo.js starts (a deferred script in <head> runs before the section's deferred script), using the
      section's own catalogue spelling when the handle is in it, so the section recognises the bottle exactly as if typed.
   Ship and rollback unit with snippets/buy-buttons.liquid (2 GR-P1008-SOLDOUT lines) and assets/gr-p1008-soldout.css: the
   rollback restores MAIN's buy-buttons.liquid AND empties the CSS. This file is inert without the block (it only acts on
   [data-gr-so] and on a homepage visit carrying ?find= / ?from=), so it may stay or be emptied. */
(function () {
  'use strict';
  if (window.__grSo) return;
  window.__grSo = 1;

  var ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=';
  var REVISION = '2024-10-15';
  var PREFIX = '$shopify:::$default:::';
  var DONE = 'gr-so-done';
  var lastEmail = '';

  function doneList() { try { return JSON.parse(sessionStorage.getItem(DONE) || '[]'); } catch (e) { return []; } }
  function remember(v) { try { var a = doneList(); if (a.indexOf(v) < 0) a.push(v); sessionStorage.setItem(DONE, JSON.stringify(a.slice(-40))); } catch (e) {} }
  function parts(box) {
    return { f: box.querySelector('.gr-so__field'), i: box.querySelector('.gr-so__in'), b: box.querySelector('.gr-so__btn'), m: box.querySelector('.gr-so__msg') };
  }
  function say(p, text, err) { p.m.textContent = text || ''; p.m.classList.toggle('is-err', !!err); p.m.hidden = !text; }
  function sealed(box, p) {
    p.f.hidden = true; p.b.hidden = true; p.b.setAttribute('aria-expanded', 'false');
    box.setAttribute('data-state', 'done');
    say(p, box.getAttribute('data-ok'));
  }
  function open(box, p) {
    p.f.hidden = false;
    p.b.setAttribute('aria-expanded', 'true');
    box.setAttribute('data-state', 'open');
    if (!p.i.value && lastEmail) p.i.value = lastEmail;
    try { p.i.focus({ preventScroll: true }); } catch (e) { p.i.focus(); }
    /* phones: keep the field and the button in view above the keyboard */
    var r = p.f.getBoundingClientRect(), vh = window.visualViewport ? visualViewport.height : innerHeight;
    if (r.top < 70 || r.bottom + 120 > vh) { try { p.f.scrollIntoView({ block: 'center' }); } catch (e) {} }
  }
  function okMail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
  function send(box, p) {
    if (p.b.getAttribute('aria-busy') === 'true') return;
    var email = (p.i.value || '').trim();
    if (!okMail(email)) { p.i.setAttribute('aria-invalid', 'true'); say(p, box.getAttribute('data-bad'), true); p.i.focus(); return; }
    p.i.removeAttribute('aria-invalid'); say(p, '');
    lastEmail = email;
    var vid = box.getAttribute('data-variant');
    var body = { data: { type: 'back-in-stock-subscription', attributes: {
      profile: { data: { type: 'profile', attributes: { email: email } } }, channels: ['EMAIL'] },
      relationships: { variant: { data: { type: 'catalog-variant', id: PREFIX + vid } } } } };
    p.b.setAttribute('aria-busy', 'true');
    fetch(ENDPOINT + encodeURIComponent(box.getAttribute('data-key') || 'UiecjN'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': REVISION },
      body: JSON.stringify(body)
    }).then(function (r) {
      p.b.removeAttribute('aria-busy');
      if (r.ok) { remember(vid); if (document.activeElement === p.i) p.i.blur(); sealed(box, p); }
      else say(p, box.getAttribute('data-err'), true);
    }).catch(function () {
      p.b.removeAttribute('aria-busy');
      say(p, box.getAttribute('data-err'), true);
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.gr-so__btn') : null;
    if (!b) return;
    var box = b.closest('[data-gr-so]');
    if (!box) return;
    e.preventDefault();
    var p = parts(box);
    if (p.f.hidden) open(box, p); else send(box, p);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || e.isComposing || e.keyCode === 229) return;
    var i = e.target && e.target.closest ? e.target.closest('.gr-so__in') : null;
    if (!i) return;
    e.preventDefault();
    var box = i.closest('[data-gr-so]');
    if (box) send(box, parts(box));
  });
  document.addEventListener('input', function (e) {
    var i = e.target;
    if (!i || !i.classList || !i.classList.contains('gr-so__in')) return;
    lastEmail = i.value.trim();
    var box = i.closest('[data-gr-so]'), p = box && parts(box);
    if (p && p.m.classList.contains('is-err')) { i.removeAttribute('aria-invalid'); say(p, ''); }
  });

  /* a size already asked for in this visit shows the confirmation again when it comes back on screen */
  function scan() {
    var done = doneList();
    if (!done.length) return;
    var boxes = document.querySelectorAll('[data-gr-so]:not([data-state="done"])');
    for (var k = 0; k < boxes.length; k++) if (done.indexOf(boxes[k].getAttribute('data-variant')) > -1) sealed(boxes[k], parts(boxes[k]));
  }
  document.addEventListener('variant:change', function () { setTimeout(scan, 0); });

  /* ---- 2. homepage Special Orders: type the perfume in ---- */
  function prefill(late) {
    var R = document.getElementById('special-orders');
    if (!R || !/[?&](find|from)=/.test(location.search)) return;
    var q; try { q = new URLSearchParams(location.search); } catch (e) { return; }
    var name = (q.get('find') || '').replace(/\s+/g, ' ').trim(), h = (q.get('from') || '').trim();
    /* clean the address bar (the hash stays): a reload or a shared link does not type it again */
    try { q.delete('find'); q.delete('from'); var s = q.toString(); history.replaceState(history.state, '', location.pathname + (s ? '?' + s : '') + location.hash); } catch (e) {}
    var form = R.querySelector('.pf-form');
    if (form && form.getAttribute('data-state') === 'sent') return;
    var B = document.getElementById('pf-b');
    if (!B || B.value.trim()) return;
    try {
      var cat = JSON.parse((R.querySelector('.pf-cat') || {}).textContent || '[]');
      for (var i = 0; i < cat.length; i++) if (cat[i][1] === h) { name = cat[i][2] + ' ' + cat[i][3]; break; }
    } catch (e) {}
    if (!name) return;
    B.value = name.slice(0, 200);
    /* only if the section already started (this file loaded late): let it hear the line */
    if (late) B.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function boot(late) { scan(); prefill(late); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(true); });
  else boot(document.readyState === 'complete');
})();
